import {InjectionToken} from "@angular/core";

export interface Translator {
  key(key: string | string[], params?: object): string;
}

export const TRANSLATOR = new InjectionToken<Translator>('Translator service for libs');
